import React from "react";
import { Paper, Typography, Box, Tooltip } from "@mui/material";

// Helper function to get primary media URL (duplicated from FrequentlyBoughtTogether)
const getPrimaryMediaUrl = (product) => {
  // ✅ For Similar Products API
  if (product?.imageUrl) {
    return product.imageUrl;
  }

  // ✅ For Full Product API
  if (product?.images?.length > 0 && product.images[0]?.url) {
    return product.images[0].thumbnailUrl;
  }

  if (product?.videos?.length > 0 && product.videos[0]?.thumbnailUrl) {
    return product.videos[0].thumbnailUrl;
  }

  return "/placeholder-product.png";
};

const SimilarProducts = ({ products, navigate }) => {
  if (!products?.length) return null;

  return (
    <Paper
      sx={{
        mt: 5,
        p: 3,
        borderRadius: 2,
        border: "1px solid #e0e0e0",
      }}
    >
      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 18,
          mb: 3,
        }}
      >
        Similar Products
      </Typography>

      <Box
        sx={{
          display: "flex",
          gap: 3,
          overflowX: "auto",
          pb: 1,
          "&::-webkit-scrollbar": { height: 6 },
          "&::-webkit-scrollbar-thumb": {
            background: "#ddd",
            borderRadius: 4,
          },
        }}
      >
        {products.slice(0, 10).map((p) => (
          <Box
            key={p._id}
            sx={{
              minWidth: 180,
              maxWidth: 180,
              flexShrink: 0,
              cursor: "pointer",
              transition: "0.2s",
              "&:hover .title": {
                color: "#C7511F",
                textDecoration: "underline",
              },
            }}
            onClick={() => navigate(`/product/${p._id}`)}
          >
            {/* IMAGE BOX */}
            <Box
              sx={{
                height: 160,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                mb: 1.5,
              }}
            >
              <img
                src={getPrimaryMediaUrl(p)}
                alt={p.title}
                loading="lazy"
                style={{
                  maxHeight: 150,
                  maxWidth: 150,
                  objectFit: "contain",
                }}
              />
            </Box>

            {/* TITLE */}
            <Tooltip title={p.title} arrow>
              <Typography
                className="title"
                sx={{
                  fontSize: 14,
                  lineHeight: "20px",
                  height: "40px",
                  overflow: "hidden",
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  textOverflow: "ellipsis",
                  color: "#007185",
                  mb: 0.5,
                }}
              >
                {p.title}
              </Typography>
            </Tooltip>

            {/* PRICE */}
            <Typography
              sx={{
                fontSize: 16,
                fontWeight: 700,
                color: "#B12704",
              }}
            >
              ₹{Number(p.price || 0).toLocaleString("en-IN")}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
};

export default SimilarProducts;